import React from "react";
import { Box, Typography } from "@mui/material";
import Strings from "../../utils/stringUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import styles from "../../assets/styles/main.module.css";
import theme from "../../utils/themeUtil";
import video from "../../assets/video/why_mm_video.mp4";

function Video() {
    return (
        <React.Fragment>
            <Box className={styles.container} mt={isMobile ? 2 : 4}>
                <Box style={{ position: "relative" }} className="wow animate__animated animate__zoomIn animate__delay-0.6s">
                    <Box className={styles.homeVideoTitle}>
                        <Box className={styles.homeVideoLogo}>
                            <img src={AppIcons.imgLogo} alt="Mahila Money" width="30px" />
                        </Box>
                        <Box ml={2}>
                            <Typography
                                variant="h6"
                                style={{ color: theme.palette.white.main, fontSize: "16px" }}
                            >
                                {Strings.whyMahilaMoney}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Video Player */}
                    <video controls width={isMobile ? "100%" : "75%"} style={{ margin: '0px auto', display: 'table' }}>
                        <source src={video} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </Box>
            </Box>
        </React.Fragment>
    );
}

export default Video;
